import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export interface IAccountClosedPayload {
  accountId: string;
  trackId: string;
}

export class AccountClosedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'AccountClosedEvent';

  constructor(public readonly payload: IAccountClosedPayload) {
  }
}
